interface Props {
  size?: number;
  onClick?: () => void;
}

export function GameWordmark({ size = 22, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className="gdisplay gwordmark"
      style={{ fontSize: size, cursor: onClick ? "pointer" : "default" }}
    >
      Brutally<span className="gwordmark-dot" />
    </button>
  );
}
